import { DataFlowColumn } from 'app/model/dataset/dataflowcolumn';
import { LoggerService } from 'app/logger/logger.service';
import { DataFlowColumnsEvent } from 'app/logger/logger.dataflow-columns-event';
import { ExpressionBasedColumnBase } from 'app/model/dataflow/expression-based.column.base';
import { ExpressionBasedColumnPattern } from 'app/model/dataflow/expression-based.column.pattern';
import { ExpressionBasedColumn } from 'app/model/dataflow/expression-based.column';
import { IResourceContext } from 'shell-models-lib';
import { getServiceInstance } from 'app/multi-contexts/modules/root/root.application';

export class DataFlowLoggingService {
    public static async logColumnInfos(contextData: IResourceContext, columns: DataFlowColumn[], entityName: string, entityType: string, owner: string): Promise<void> {
        if (columns?.length) {
            const logger = await getServiceInstance<LoggerService>(contextData, 'LoggerService');
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const properties: any = {};
            properties['totalColumns'] = columns.length;
            columns.filter((column) => !!column.dataFlowColumnType).forEach((column) => {
                if (!properties[column.dataFlowColumnType.typeString]) {
                    properties[column.dataFlowColumnType.typeString] = 0;
                }

                properties[column.dataFlowColumnType.typeString]++;
            });

            logger.logEvent(new DataFlowColumnsEvent(entityName, entityType, properties, owner));
        }
    }

    public static async logExpressionColumnInfos(contextData: IResourceContext, columns: ExpressionBasedColumnBase[], entityName: string, entityType: string, owner: string): Promise<void> {
        if (columns?.length) {
            let totalColumns: number = 0;
            let totalColumnPatterns: number = 0;
            columns.forEach((column) => {
                if (column instanceof ExpressionBasedColumnPattern) {
                    totalColumnPatterns++;
                } else if (column instanceof ExpressionBasedColumn) {
                    totalColumns++;
                }
            });
            if (totalColumns > 0 || totalColumnPatterns > 0) {
                const logger = await getServiceInstance<LoggerService>(contextData, 'LoggerService');
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const properties: any = {};
                properties['totalColumns'] = totalColumns;
                properties['totalColumnPatterns'] = totalColumnPatterns;
                logger.logEvent(new DataFlowColumnsEvent(entityName, entityType, properties, owner));
            }
        }
    }
}
